function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.9249 23.9249",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23.9249,11.96245A11.96245,11.96245,0,1,0,11.96245,23.9249,11.97295,11.97295,0,0,0,23.9249,11.96245",
    style: {
      fill: "#4d9046",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8146,15.14446c0,2.8997-2.81356,6.27311-7.5507,6.27311A12.06729,12.06729,0,0,1,4.90939,18.738V14.97221a9.40763,9.40763,0,0,0,7.35451,4.02416c1.77523,0,3.20116-1.01441,3.20116-2.1006,0-4.08637-10.70879-1.55991-10.70879-8.60818,0-3.69879,3.61266-5.68934,6.85688-5.68934a11.41378,11.41378,0,0,1,7.05306,2.37813v3.139a9.91156,9.91156,0,0,0-7.11527-3.3782c-1.66517,0-2.61738.88522-2.61738,1.92356,0,4.37348,10.881,1.30152,10.881,8.48377",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.9249,
    height: 23.9249,
    style: {
      fill: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS);
export default __webpack_public_path__ + "static/media/s.e17895da50baca1aa7ebbb55e48a285d.svg";
export { ForwardRef as ReactComponent };